export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "actions": [
    {
      title: "Reprint Label",
      cls: "view-label",
      icon: "file-text-o",
      disabled:false
    },
    {
      title: "Customer Receipt & OTP",
      cls: "receipt-tacking",
      icon: "file-text-o",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/fxoReprintLabels/filter/actionOptions.js